function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class PredictiveSearch extends HTMLElement {
  constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector(
			'#predictive-search-results'
		);
		this.input.addEventListener(
			'input',
			debounce((event) => {
				this.onChange(event);
			}, 300).bind(this)
		);
	}

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    console.log(searchTerm);
    fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product,article&resources[limit]=8&resources[options][fields]=title,body,product_type&section_id=predictive-search-results`)
      .then((response) => {

        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        this.predictiveSearchResults.innerHTML = '<div class="loading"><svg class="icon icon--is-spinning" aria-hidden="true" viewBox="0 0 16 16"><title>Loading</title><g stroke-width="1" fill="currentColor" stroke="currentColor"><path d="M.5,8a7.5,7.5,0,1,1,1.91,5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g></svg><h3>Searching...</h3></div>';
        this.open();
        
        return response.text();

      })
      .then((text) => {

        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search-results').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
}

customElements.define('predictive-search', PredictiveSearch);
